var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.58333 15.333H36.4167V11.4997H9.58333V15.333ZM9.58333 42.1663C8.52917 42.1663 7.62674 41.791 6.87604 41.0403C6.12535 40.2896 5.75 39.3872 5.75 38.333V11.4997C5.75 10.4455 6.12535 9.54308 6.87604 8.79238C7.62674 8.04169 8.52917 7.66634 9.58333 7.66634H11.5V3.83301H15.3333V7.66634H30.6667V3.83301H34.5V7.66634H36.4167C37.4708 7.66634 38.3733 8.04169 39.124 8.79238C39.8747 9.54308 40.25 10.4455 40.25 11.4997V22.3768C39.6431 22.0893 39.0201 21.8497 38.3812 21.658C37.7424 21.4663 37.0875 21.3226 36.4167 21.2268V19.1663H9.58333V38.333H21.6583C21.8819 39.0358 22.1455 39.7066 22.449 40.3455C22.7524 40.9844 23.1118 41.5913 23.5271 42.1663H9.58333ZM34.5 44.083C31.8486 44.083 29.5885 43.1486 27.7198 41.2799C25.851 39.4111 24.9167 37.1511 24.9167 34.4997C24.9167 31.8483 25.851 29.5882 27.7198 27.7195C29.5885 25.8507 31.8486 24.9163 34.5 24.9163C37.1514 24.9163 39.4115 25.8507 41.2802 27.7195C43.149 29.5882 44.0833 31.8483 44.0833 34.4997C44.0833 37.1511 43.149 39.4111 41.2802 41.2799C39.4115 43.1486 37.1514 44.083 34.5 44.083ZM37.7104 39.0518L39.0521 37.7101L35.4583 34.1163V28.7497H33.5417V34.883L37.7104 39.0518Z",
    fill: "#7A53FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/calendarIcon.a4a246931135ae98395e3c111180bc37.svg";
export { ForwardRef as ReactComponent };